import { supabase } from '@/integrations/supabase/client';
import { getAllCourses } from '@/data/courses';
import { SQL_COURSES } from '@/data/sql';
import { PYTHON_COURSES } from '@/data/python';
import { AI_COURSES } from '@/data/ai/courses';
import { JAVASCRIPT_COURSES } from '@/data/javascript';
import { AZURE_COURSES } from '@/data/azure';
import { ML_COURSES } from '@/data/ml';
import { TABLEAU_COURSES } from '@/data/tableau';
import { POWERBI_COURSES } from '@/data/powerbi';
import { AWS_COURSES } from '@/data/aws/courses';
import { GCP_COURSES } from '@/data/gcp';
import { JAVA_COURSES } from '@/data/java';
import { DOTNET_COURSES } from '@/data/dotnet';
import { DATASCIENCE_COURSES } from '@/data/datascience';
import { DATAENGINEERING_COURSES } from '@/data/dataengineering';
import { MOBILE_COURSES } from '@/data/mobile';
import { BACKEND_COURSES } from '@/data/backend';
import { DATABASE_COURSES } from '@/data/database';
import { SECURITY_COURSES } from '@/data/security';
import { BLOCKCHAIN_COURSES } from '@/data/blockchain';
import { ENTERPRISE_TRAINING_COURSES } from '@/data/enterprise-training';
import { UI_UX_COURSES } from '@/data/ui-ux-design';
import { GRAPHICS_PROGRAMMING_COURSES } from '@/data/graphics-programming';
import { DEVOPS_COURSES } from '@/data/devops';
import { APPSEC_COURSES } from '@/data/appsec';
import { PROFESSIONAL_DEVELOPMENT_COURSES } from '@/data/professional-development';
import { INFRASTRUCTURE_COURSES } from '@/data/infrastructure';
import { FRONTEND_ADVANCED_COURSES } from '@/data/frontend-advanced';
import { TESTING_MODERN_COURSES } from '@/data/testing-modern';
import { WEB3_DEVELOPMENT_COURSES } from '@/data/web3-development';
import { SERVERLESS_EDGE_COURSES } from '@/data/serverless-edge';
import { ADVANCED_API_COURSES } from '@/data/advanced-api';
import { AUTOMATION_COURSES } from '@/data/automation';
import { RPA_COURSES } from '@/data/rpa';
import { CROSS_PLATFORM_COURSES } from '@/data/cross-platform';
import { CSHARP_COURSES } from '@/data/csharp';
import { EDGE_COMPUTING_COURSES } from '@/data/edge-computing';
import { GREEN_TECH_COURSES } from '@/data/green-tech';
import { KUBERNETES_MASTERY_COURSES } from '@/data/kubernetes-mastery';
import { MODERN_FRONTEND_COURSES } from '@/data/modern-frontend';
import { NO_CODE_COURSES } from '@/data/no-code';
import { RUST_COURSES } from '@/data/rust';
import { SELENIUM_COURSES } from '@/data/selenium/courses';
import { SQL_PHASE1_COURSES } from '@/data/sql/phase1';
import { getAllAliasesForCourse } from '@/config/courseIdAliases';

export interface CourseModuleInfo {
  courseId: string;
  courseTitle: string;
  courseType: string;
  totalModules: number;
  moduleIds: string[];
}

export class UniversalCourseRegistry {
  private static courseModuleMap: Map<string, CourseModuleInfo> = new Map();
  private static initialized = false;
  private static databaseInitialized = false;

  static initialize() {
    if (this.initialized) {
      console.log('✅ Registry already initialized');
      return;
    }

    console.log('🚀 Initializing Universal Course Registry with ALL course types...');

    // Register all course types with comprehensive coverage
    this.registerCourseType(getAllCourses(), 'general');
    this.registerCourseType(SQL_COURSES, 'sql');
    this.registerCourseType(PYTHON_COURSES, 'python');
    this.registerCourseType(AI_COURSES, 'ai');
    this.registerCourseType(JAVASCRIPT_COURSES, 'javascript');
    this.registerCourseType(AZURE_COURSES, 'azure');
    this.registerCourseType(ML_COURSES, 'ml');
    this.registerCourseType(TABLEAU_COURSES, 'tableau');
    this.registerCourseType(POWERBI_COURSES, 'powerbi');
    this.registerCourseType(AWS_COURSES, 'aws');
    this.registerCourseType(GCP_COURSES, 'gcp');
    this.registerCourseType(JAVA_COURSES, 'java');
    this.registerCourseType(DOTNET_COURSES, 'dotnet');
    this.registerCourseType(DATASCIENCE_COURSES, 'datascience');
    this.registerCourseType(DATAENGINEERING_COURSES, 'dataengineering');
    this.registerCourseType(MOBILE_COURSES, 'mobile');
    this.registerCourseType(BACKEND_COURSES, 'backend');
    this.registerCourseType(DATABASE_COURSES, 'database');
    this.registerCourseType(SECURITY_COURSES, 'security');
    this.registerCourseType(BLOCKCHAIN_COURSES, 'blockchain');
    this.registerCourseType(ENTERPRISE_TRAINING_COURSES, 'enterprise-training');
    this.registerCourseType(UI_UX_COURSES, 'ui-ux-design');
    this.registerCourseType(GRAPHICS_PROGRAMMING_COURSES, 'graphics-programming');
    this.registerCourseType(DEVOPS_COURSES, 'devops');
    this.registerCourseType(APPSEC_COURSES, 'appsec');
    this.registerCourseType(PROFESSIONAL_DEVELOPMENT_COURSES, 'professional-development');
    this.registerCourseType(INFRASTRUCTURE_COURSES, 'infrastructure');
    this.registerCourseType(FRONTEND_ADVANCED_COURSES, 'frontend-advanced');
    this.registerCourseType(TESTING_MODERN_COURSES, 'testing-modern');
    this.registerCourseType(WEB3_DEVELOPMENT_COURSES, 'web3-development');
    this.registerCourseType(SERVERLESS_EDGE_COURSES, 'serverless-edge');
    
    // Register missing course types for complete coverage
    this.registerCourseType(ADVANCED_API_COURSES, 'advanced-api');
    this.registerCourseType(AUTOMATION_COURSES, 'automation');
    this.registerCourseType(RPA_COURSES, 'rpa-tools');
    this.registerCourseType(CROSS_PLATFORM_COURSES, 'cross-platform');
    this.registerCourseType(CSHARP_COURSES, 'csharp');
    this.registerCourseType(EDGE_COMPUTING_COURSES, 'edge-computing');
    this.registerCourseType(GREEN_TECH_COURSES, 'green-tech');
    this.registerCourseType(KUBERNETES_MASTERY_COURSES, 'kubernetes');
    this.registerCourseType(MODERN_FRONTEND_COURSES, 'modern-frontend');
    this.registerCourseType(NO_CODE_COURSES, 'no-code');
    this.registerCourseType(RUST_COURSES, 'rust');
    this.registerCourseType(SELENIUM_COURSES, 'selenium');
    this.registerCourseType(SQL_PHASE1_COURSES, 'sql-phase1');

    this.initialized = true;
    console.log(`✅ Successfully registered ${this.courseModuleMap.size} courses across all categories`);
    
    // Phase 1: Initialize from database asynchronously
    this.initializeFromDatabase();
    
    console.log(`✅ Universal Course Registry initialized with ${this.courseModuleMap.size} courses`);
    console.log('📊 Course distribution:', this.getCourseDistribution());
  }

  /**
   * Phase 1: Initialize courses from database
   * Fills gap for database-only courses like 'machine-learning-intro'
   * Database courses MERGE with static courses (database takes priority)
   */
  static async initializeFromDatabase() {
    if (this.databaseInitialized) {
      console.log('✅ Database registry already initialized');
      return;
    }

    try {
      console.log('🔄 Initializing Universal Course Registry from database...');
      
      // Fetch all courses and their modules from database
      const [coursesResult, modulesResult] = await Promise.all([
        supabase
          .from('courses')
          .select('id, title, category, is_active')
          .eq('is_active', true),
        supabase
          .from('course_modules')
          .select('course_id, module_id, is_enabled')
          .eq('is_enabled', true)
      ]);

      if (coursesResult.error) {
        console.error('❌ Error fetching courses from database:', coursesResult.error);
        return;
      }

      if (modulesResult.error) {
        console.error('❌ Error fetching course modules from database:', modulesResult.error);
        return;
      }

      const courses = coursesResult.data || [];
      const modules = modulesResult.data || [];

      console.log(`📚 Found ${courses.length} active courses in database`);
      console.log(`📦 Found ${modules.length} enabled modules in database`);

      // Register each course from database (overwrites static if exists)
      courses.forEach(course => {
        const courseModules = modules.filter(m => m.course_id === course.id);
        const moduleIds = courseModules.map(m => m.module_id);
        
        this.courseModuleMap.set(course.id, {
          courseId: course.id,
          courseTitle: course.title,
          courseType: course.category || 'general',
          totalModules: moduleIds.length,
          moduleIds
        });

        console.log(`✓ [DB] Registered course: ${course.id} with ${moduleIds.length} modules`);
      });

      this.databaseInitialized = true;
      console.log(`✅ Database initialization complete. Total courses: ${this.courseModuleMap.size}`);
      
    } catch (error) {
      console.error('❌ Error initializing from database:', error);
    }
  }

  private static registerCourseType(courses: any[], type: string) {
    if (!courses || courses.length === 0) {
      console.warn(`⚠️ No courses found for type: ${type}`);
      return;
    }

    courses.forEach(course => {
      const moduleIds = course.modules?.map((m: any) => m.id) || [];
      
      this.courseModuleMap.set(course.id, {
        courseId: course.id,
        courseTitle: course.title,
        courseType: type,
        totalModules: moduleIds.length,
        moduleIds
      });

      console.log(`✓ Registered ${type} course: ${course.id} with ${moduleIds.length} modules`);
    });
  }

  /**
   * Phase 6: Get course info with alias support
   * Checks aliases if direct lookup fails (e.g., machine-learning-intro -> ml-fundamentals)
   */
  static getCourseInfo(courseId: string): CourseModuleInfo | null {
    this.initialize();
    
    // Direct lookup first
    let info = this.courseModuleMap.get(courseId);
    
    // Phase 6: If not found, try aliases
    if (!info) {
      const aliases = getAllAliasesForCourse(courseId);
      for (const alias of aliases) {
        info = this.courseModuleMap.get(alias);
        if (info) {
          console.log(`✓ Found course via alias: ${courseId} -> ${alias}`);
          break;
        }
      }
    }
    
    if (!info) {
      console.warn(`❌ Course info not found for courseId: ${courseId}`);
      console.log('Available courses:', Array.from(this.courseModuleMap.keys()).slice(0, 10));
    }
    return info || null;
  }

  static getAllModulesForCourse(courseId: string): string[] {
    const courseInfo = this.getCourseInfo(courseId);
    return courseInfo?.moduleIds || [];
  }

  static getTotalModulesCount(courseId: string): number {
    const courseInfo = this.getCourseInfo(courseId);
    return courseInfo?.totalModules || 0;
  }

  static validateCourseExists(courseId: string): boolean {
    this.initialize();
    return this.courseModuleMap.has(courseId);
  }

  static getAllRegisteredCourses(): CourseModuleInfo[] {
    this.initialize();
    return Array.from(this.courseModuleMap.values());
  }

  static getCourseType(courseId: string): string {
    const courseInfo = this.getCourseInfo(courseId);
    return courseInfo?.courseType || 'basic';
  }

  static getCourseDistribution() {
    this.initialize();
    const distribution: Record<string, number> = {};
    this.courseModuleMap.forEach(course => {
      distribution[course.courseType] = (distribution[course.courseType] || 0) + 1;
    });
    return distribution;
  }

  static getRegistrationStatus() {
    this.initialize();
    return {
      totalCourses: this.courseModuleMap.size,
      courseTypes: Object.keys(this.getCourseDistribution()),
      isComplete: this.courseModuleMap.size > 0,
      distribution: this.getCourseDistribution()
    };
  }
}
